import {QuestionModelV3} from '@albert-io/models';
import React from 'react';
import {DroppableItem} from './BankItems.react';
import useQuestionAndDrafts from '../../V2/useQuestionAndDrafts.hook';

interface Props {
  question: QuestionModelV3;
  handleItemClick: (itemId: string) => void;
  handleSlotClick: (slotId: string) => void;
}
const DropSlots = ({question, handleItemClick, handleSlotClick}: Props) => {
  const {useStoreHook} = useQuestionAndDrafts(question);
  const dropSlots = useStoreHook((state) => state.dropSlots);

  return (
    <div className='mcq__options-grid mt-x4 flex gap-x1'>
      {dropSlots.map((slot) => {
        return (
          <DroppableItem
            key={slot.id}
            slot={slot}
            useStoreHook={useStoreHook}
            onClick={() => handleSlotClick(slot.id)}
            onItemClick={handleItemClick}
          />
        );
      })}
    </div>
  );
};
export default DropSlots;
